module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validation),
      expression: "validation"
    }],
    staticClass: "form-control",
    attrs: {
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option['.key'],
        "selected": _vm.value == option['.key']
      }
    }, [_vm._v("\n      " + _vm._s(option.name) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb90a95","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Form/FormSelect.vue
// module id = 631
// module chunks = 1